import {
  GET_UTILITY_REQUEST_ISSUE_TYPES,
  GET_UTILITY_REQUEST_ISSUE_TYPES_SUCCESS,
  GET_UTILITY_REQUEST_ISSUE_TYPES_ERROR,
  GET_UTILITY_REQUEST_ISSUE_TYPES_EMPTY,
} from '../../actions.js';

const initialState = {
  data: null,
  loading: false,
  error: null,
};

const GetUtilityRequestIssueTypes = (state = initialState, action) => {
  switch (action.type) {
    case GET_UTILITY_REQUEST_ISSUE_TYPES:
      return { ...state, loading: true };

    case GET_UTILITY_REQUEST_ISSUE_TYPES_SUCCESS:
      return { ...state, loading: false, data: action.payload };

    case GET_UTILITY_REQUEST_ISSUE_TYPES_ERROR:
      return { ...state, loading: false, error: action.payload };

    case GET_UTILITY_REQUEST_ISSUE_TYPES_EMPTY:
      return { ...initialState };

    default:
      return state;
  }
};

export default GetUtilityRequestIssueTypes;
